import { createFileRoute } from "@tanstack/react-router";
import { CoursePlayer } from "@/lib/lazyPages";
import appCss from "@/styles/app.css?url";
// Same hashed file the @font-face in styles/course-player.css points at, so the
// preload and the CSS resolve to one request instead of two.
import fredokaFontUrl from "@/assets/fonts/fredoka-var-latin.woff2?url";
import { seoHead } from "@/lib/seo/head";
import { hasStoredSession } from "@/lib/telemetry/webVitals";

export const Route = createFileRoute("/course/$courseId")({
  head: () => {
    const seo = seoHead({ title: "Course", noindex: true });
    return {
      ...seo,
      links: [
        ...seo.links,
        { rel: "stylesheet", href: appCss },
        // Fredoka is the player's heading family. Without a preload it is only
        // discovered after app.css parses, so headings paint in the fallback
        // and reflow mid-lesson; this is the one route that uses it.
        {
          rel: "preload",
          as: "font",
          type: "font/woff2",
          href: fredokaFontUrl,
          crossOrigin: "anonymous",
        },
      ],
    };
  },
  // Start the player code and the course rows together, instead of waiting
  // for the player code before asking for the course (phones felt this most).
  beforeLoad: ({ params }) => {
    if (typeof window === "undefined" || !hasStoredSession()) return;
    void import("@/pages/CoursePlayer");
    void import("@/hooks/useCourseData").then((m) => m.prefetchCourseRaw(params.courseId));
  },
  component: CoursePlayer,
});
